var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgAddcomponent = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1689_54103",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 19
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1689_54103)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 12.5H15V5H6V12.5ZM6 14C5.5875 14 5.23438 13.8531 4.94063 13.5594C4.64688 13.2656 4.5 12.9125 4.5 12.5V3.5C4.5 3.0875 4.64688 2.73438 4.94063 2.44063C5.23438 2.14688 5.5875 2 6 2H15C15.4125 2 15.7656 2.14688 16.0594 2.44063C16.3531 2.73438 16.5 3.0875 16.5 3.5V12.5C16.5 12.9125 16.3531 13.2656 16.0594 13.5594C15.7656 13.8531 15.4125 14 15 14H6ZM3 17C2.5875 17 2.23438 16.8531 1.94063 16.5594C1.64688 16.2656 1.5 15.9125 1.5 15.5V5.75C1.5 5.5375 1.57187 5.35938 1.71562 5.21562C1.85938 5.07187 2.0375 5 2.25 5C2.4625 5 2.64062 5.07187 2.78437 5.21562C2.92813 5.35938 3 5.5375 3 5.75V15.5H12.75C12.9625 15.5 13.1406 15.5719 13.2844 15.7156C13.4281 15.8594 13.5 16.0375 13.5 16.25C13.5 16.4625 13.4281 16.6406 13.2844 16.7844C13.1406 16.9281 12.9625 17 12.75 17H3Z",
    fill: "#1E293B"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAddcomponent);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/addcomponent.68361addb82692deee7996c75a8a045d.svg";